import React from "react";

import "../../styles/pages/home/Team.scss";
import Tesla from "../../shared/components/Tesla";

// Removed unused Content function

export default function Team() {
  return (
    <div className="team">
      <Tesla />
    </div>
  );
}
